/**
 * FieldError Component
 * ====================
 * Displays validation error message for a single form field.
 * Integrates seamlessly with the validation system.
 */

import React from 'react';
import clsx from 'clsx';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

interface FieldErrorProps {
  error?: string;
  visible?: boolean;
  className?: string;
  showIcon?: boolean;
}

/**
 * FieldError: Displays a single field's validation error
 */
const FieldError: React.FC<FieldErrorProps> = ({
  error,
  visible = true,
  className,
  showIcon = true,
}) => {
  if (!error || !visible) {
    return null;
  }

  return (
    <div
      className={clsx(
        'flex items-start gap-2 mt-1.5 text-sm',
        'text-danger-500 dark:text-danger-400',
        className
      )}
      role="alert"
      aria-live="polite"
    >
      {showIcon && (
        <ExclamationCircleIcon
          className="w-4 h-4 flex-shrink-0 mt-0.5"
          aria-hidden="true"
        />
      )}
      <span className="flex-1">{error}</span>
    </div>
  );
};

export default FieldError;
